module.exports = __webpack_public_path__ + "img/more@2x.67f7b20b.png";